import {RemoteGetAuthRequests} from 'data/usecases/private/authorizations';
import {GetAuthRequests} from 'domain/usecases/private/authorizations';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {AuthorizationsFlowEndpoints} from '../../endpoints';

export const makeGetAuthRequests = (): GetAuthRequests =>
	new RemoteGetAuthRequests(
		makeBFFApiUrl(AuthorizationsFlowEndpoints.requests),
		makeAuthorizeHttpClientDecorator(),
	);
